import Box from "@cloudscape-design/components/box";
import Spinner from "@cloudscape-design/components/spinner";
import { lazy, Suspense, useEffect } from "react";
import { readToken } from "./api/client";
import { trackPageView } from "./lib/analytics";
import { captureReferralCode } from "./lib/referral";
import { PublicApp } from "./pages/public/PublicApp";
import { isMemberRoute } from "./router/routes";
import { navigate, useLocation } from "./router/useRoute";

// Ranh giới lazy duy nhất của app: console thành viên (Table, Wizard, Cards…)
// không được tải cùng trang đăng nhập.
const MemberApp = lazy(async () => ({ default: (await import("./pages/member/MemberApp")).MemberApp }));

export function App() {
  const { pathname, route, search } = useLocation();
  const member = isMemberRoute(route);
  const authenticated = Boolean(readToken());

  // Bắt `?ref=` ở mọi trang, không riêng trang đăng ký: đối tác hay phát link
  // trỏ thẳng vào trang chủ hoặc trang bảng giá.
  useEffect(() => {
    captureReferralCode(search);
  }, [search]);

  useEffect(() => {
    if (member && !authenticated) navigate("/login", { replace: true });
  }, [member, authenticated]);

  /*
    Một lượt xem trang GA4 mỗi lần đổi đường dẫn — cả lần tải đầu, điều hướng
    trong app lẫn back/forward. Effect của cha chạy sau effect của trang con, nên
    `document.title` lúc này đã là tiêu đề của trang mới (PublicShell đặt nó).
  */
  useEffect(() => {
    trackPageView();
  }, [pathname, search]);

  if (member && authenticated) {
    return (
      <Suspense fallback={<FullPageSpinner />}>
        <MemberApp />
      </Suspense>
    );
  }

  return <PublicApp />;
}

function FullPageSpinner() {
  return (
    <Box margin={{ top: "xxxl" }} textAlign="center">
      <Spinner size="large" />
      <Box variant="p" padding={{ top: "s" }} color="text-body-secondary">
        Đang tải bảng điều khiển
      </Box>
    </Box>
  );
}
